<template>
  <div>
    <ul>
      <li><router-link :to="{name:'Home'}">Aquí</router-link></li>
      <li><router-link :to="{name:'Victimas'}">Víctimas</router-link></li>
      <li><router-link :to="{name:'Condenados'}">Condenados</router-link></li>
    </ul>
  </div>
</template>

<script>
import ResultList from "../components/ResultList.vue";
export default {
  name: "Home",
  components: {
    ResultList,
  },
};
</script>
